import React from 'react';
import AccessMethodAccordionCard from './AccessMethodAccordionCard';
import { AccessMethodType } from './AccessMethodFormData';

export default function EmployerAgentWSCard(): JSX.Element {
  return (
    <AccessMethodAccordionCard
      id="agency-ws"
      label="Web Services - Employer Agent"
      value={AccessMethodType.AGENCY_WS}
      body="Your company plans to develop or use software that connects to E-Verify to verify employment eligibility for clients’ employees and its own employees."
      moreDetails={
        <>
          <p className="margin-top-3">This account access allows you to:</p>
          <ul>
            <li>Use or develop software that utilizes E-Verify APIs</li>
            <li>Create and manage cases for company’s employees and your own employees</li>
            <li>Create and manage cases on the E-Verify website for your company’s employees, if needed</li>
            <li>Manage company account information</li>
            <li>Add, edit, and delete users</li>
            <li>Add, edit, and delete locations where employees are hired and complete Form I-9</li>
          </ul>
        </>
      }
    />
  );
}
